import styled from "styled-components";
import { colors } from "../../../consts";

import WrapperContainer from "../../Containers/WrapperContainer";
import FlexContainers from "../../Containers/FlexContainers";
import { Paragraph2 } from "../../Text/Paragraphs";

export const LineChartContainer = styled(WrapperContainer)`
  width: 100%;
  position: relative;
`;

export const TitleWrapper = styled(WrapperContainer)`
  ${Paragraph2} {
    color: ${colors.RAISIN_80};
  }

  span {
    color: ${colors.RAISIN_100};
    font-weight: 600;
  }
`;

export const Line = styled(FlexContainers.FlexRowStart)`
  width: 100%;
  height: 8px;
  border-radius: 8px;

  display: flex;

  background: ${colors.RAISIN_10};
  overflow: hidden;
`;

export const Section = styled.div`
  height: 100%;
  width: ${(props) => (props.width ? `${props.width}%` : 0)};
  background: ${(props) => props.color && props.color};
`;

export const TotalDetails = styled.span`
  margin-left: 5px;
  font-weight: 400 !important;
  color: ${colors.RAISIN_50}!important;
`;
